<template>
  <transition name="modal">
    <div class="modal-mask" ref="modalElement">
      <div class="modal-wrapper" @click.self="$emit('close')">
        <div
          class="modal-container"
          :class="[{ audioStyle: audioStyle }]"
          :style="`width:${modalWidth}; height:${modalHeight};`"
        >
          <!-- <b-tooltip content="Zamknij" -->
          <button
            type="close"
            :title="getTooltips['close']"
            @click="close"
            name="close"
            class="close-button"
            v-if="hideWhenGameActive"
            :style="`width:${offset.iconSize}px; height:${offset.iconSize}px; top:${offset.topOffset}%!important; left:${offset.leftOffset}%!important;`"
          >
            <svg fill="#ffffff" viewBox="0 0 24 24">
              <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                fill="rgb(144, 144, 144)"
              />
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </button>
          <!-- </b-tooltip> -->
          <div
            class="modal-body"
            :class="[{ 'image-zoom-active-class': imageZoomActive }, { imageModalActiveClass: isModalImageActive }]"
          >
            <slot name="body"> default body </slot>
          </div>
          <!-- ukrywam footer -->
          <!-- <div class="modal-footer">
          <slot name="footer">
          </slot>
        </div> -->
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/javascript">
import _ from 'lodash';
import $ from 'jquery';
export default {
  name: 'tr-modal',
  props: {
    width: {
      type: null,
      default: function () {
        return '';
      },
    },
    height: {
      type: null,
      default: function () {
        return '';
      },
    },
    name: {
      type: null,
      default: function () {
        return '';
      },
    },
    audioCss: {
      type: null,
      default: function () {
        return false;
      },
    },
  },
  data: function () {
    return {
      // showModal: false
    };
  },
  mounted: function () {
    console.log('MODAL MOUNT');
    // this.$store.commit( 'TOGGLE_MODAL_ACTIVE', true );
    if (this.name === 'modal-zoomIn') {
      let test = require('dragscroll');
      test.reset();
    } else if (this.name === 'modal-gallery') {
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
      this.$store.commit('TOGGLE_UI_DISABLE', true);
    } else if (this.name === 'modal-film') {
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
      this.$store.commit('TOGGLE_UI_DISABLE', true);
    } else if (this.name === 'modal-audio') {
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
      this.$store.commit('TOGGLE_UI_DISABLE', true);
    } else if (/^modal-image/.test(this.name)) {
      this.$store.commit('TOGGLE_UI_DISABLE', true);
    } else if (this.name === 'modal-scratch') {
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
      this.$store.commit('TOGGLE_UI_DISABLE', true);
    } else if (this.name === 'modal-word') {
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
      this.$store.commit('TOGGLE_UI_DISABLE', true);
    } else if (this.name === 'modal-paint') {
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
      this.$store.commit('TOGGLE_UI_DISABLE', true);
    } else if (this.name === 'modal-coloring') {
      this.$store.commit('TOGGLE_MODAL_ACTIVE', true);
    }
  },
  methods: {
    close() {
      this.$emit('close');
      this.$store.commit('TOGGLE_MODAL_ACTIVE', false);
      this.$store.commit('TOGGLE_UI_DISABLE', false);
    },
  },
  computed: {
    modalWidth: function () {
      return this.width + '%';
    },
    modalHeight: function () {
      return this.height + '%';
    },
    audioStyle: function () {
      return this.audioCss ? true : false;
    },
    imageZoomActive() {
      return this.$store.getters.imageZoomActive;
    },
    hideWhenGameActive() {
      return !this.$store.getters.gameActive;
    },
    isModalImageActive() {
      return this.$store.getters.isModalImageActive;
    },
    offset() {
      let iconSize = 64;
      let topOffset = 43;
      let leftOffset = 97;
      let width = $('#scaleable-wrapper').width();
      if (width >= 1920) {
        iconSize = 50;
      } else if (width >= 1440 && width < 1920) {
        iconSize = 50;
      } else if (width >= 1280 && width < 1440) {
        iconSize = 47;
        // } else if( width >= 1024 && width < 1280 ) {
        // iconSize = 32;
      } else {
        // iconSize = 20;
        iconSize = 32;
      }

      if (
        this.name === 'modal-scratch' ||
        this.name === 'modal-word' ||
        this.name === 'modal-paint' ||
        this.name === 'modal-coloring'
      ) {
        topOffset = 28;
        leftOffset = 80;
      } else {
        topOffset = this.name === 'modal-gallery' ? -4.5 : 0.5;
      }
      return { topOffset, leftOffset, iconSize };
    },
    getTooltips() {
      return this.$store.getters.getTooltips;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
.modal-game-container {
  position: absolute;
  width: 100vw;
  height: calc(var(--vh, 1vh) * 100);
  top: 0;
  left: 0;
  display: block;
  overflow: hidden;
  modal-wrapper {
    z-index: 1001;
    position: inherit;
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    /*width: 300px;*/
    position: inherit;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    z-index: 1002;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }
  .modal-body {
    // margin: 20px 0;
    margin: 0;
    padding: 0;
    position: relative;
  }

  .modal-default-button {
    float: right;
  }
  // The following styles are auto-applied to elements with transition="modal"
  //  when their visibility is toggled by Vue.js. You can easily play with the
  //   modal transition by editing these styles.
  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);

    .close-button {
      pointer-events: auto;
      opacity: 0;
      transition: opacity 4s ease;
    }
  }
  .close-button {
    pointer-events: auto;
    position: absolute;
    top: 0;
    right: 0;
    opacity: 1;
    z-index: 1003;
    cursor: pointer;
    outline: none;
    border: none;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    top: -47px !important;
    right: -50px !important;
    display: flex;
    transform: scale(1);
    svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    &:hover {
      svg {
        path:first-child {
          fill: #5d5d5d;
          transition: all 0.4s ease;
        }
      }
      background-color: $borderColor;
      transform: scale(1.1);
      transition: all 0.4s ease;
      // opacity: 1;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.audio,
.file,
.interacive,
.url {
  .modal-mask {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    z-index: 1001;
    position: inherit;
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    /*width: 300px;*/
    position: inherit;
    margin: 0 auto;
    z-index: 1002;
    padding: 20px 30px;
    background-color: #fff;
    // background-color: #b3b3b3;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }
  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }
  // The following styles are auto-applied to elements with transition="modal"
  //  when their visibility is toggled by Vue.js. You can easily play with the
  //   modal transition by editing these styles.
  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);

    .close-button {
      pointer-events: auto;
      opacity: 0;
      transition: opacity 4s ease;
    }
  }
  .close-button {
    pointer-events: auto;
    position: absolute;
    top: 0;
    right: 0;
    opacity: 1;
    z-index: 1003;
    cursor: pointer;
    outline: none;
    border: none;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    top: -47px !important;
    right: -50px !important;
    display: flex;
    transform: scale(1);
    svg {
      path:first-child {
        fill: #5d5d5d;
        transition: all 0.4s ease;
      }
    }
    &:hover {
      svg {
        path:first-child {
          fill: #5d5d5d;
          transition: all 0.4s ease;
        }
      }
      background-color: $borderColor;
      // transform: scale(1.1);
      transition: all 0.4s ease;
      // opacity: 1;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.audioStyle {
  width: 100% !important;
  height: 100% !important;
  // background-color: transparent !important;
  // background-color: rgba(0, 0, 0, 0.3) !important;
  box-shadow: none !important;
  .modal-body {
    height: 100%;
  }
  .close-button {
    pointer-events: auto;
    position: absolute;
    top: 0;
    right: 0;
    opacity: 1;
    z-index: 1003;
    cursor: pointer;
    outline: none;
    border: none;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    // top: -47px !important;
    right: 0 !important;
    display: flex;
    transform: scale(1);
    svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    &:hover {
      svg {
        path:first-child {
          fill: #5d5d5d;
          transition: all 0.4s ease;
        }
      }
      background-color: $borderColor;
      transform: scale(1.1);
      transition: all 0.4s ease;
      // opacity: 1;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.gallery {
  .modal-mask {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    z-index: 1001;
    position: inherit;
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    /*width: 300px;*/
    position: inherit;
    margin: 0 auto;
    z-index: 1002;
    // padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }
  .modal-body {
    margin: 0;
    padding: 0;
    // margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }
  // The following styles are auto-applied to elements with transition="modal"
  //  when their visibility is toggled by Vue.js. You can easily play with the
  //   modal transition by editing these styles.
  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);

    .close-button {
      pointer-events: auto;
      opacity: 0;
      transition: opacity 4s ease;
    }
  }
  .close-button {
    pointer-events: auto;
    position: absolute;
    opacity: 1;
    z-index: 1003;
    cursor: pointer;
    outline: none;
    border: none;
    background-color: rgba(0, 0, 0, 0.15);
    border-radius: 50%;
    // transition: opacity 4s ease;
    top: -47px !important;
    right: -50px !important;
    // transition: background-color 0.4s ease;
    display: flex;
    transform: scale(1);
    svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    &:hover {
      svg {
        path:first-child {
          fill: #5d5d5d;
          transition: all 0.4s ease;
        }
      }
      background-color: $borderColor;
      transform: scale(1.1);
      transition: all 0.4s ease;
      // opacity: 1;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .image-zoom-active-class {
    padding: 0 !important;
    margin: 0 !important;
  }
}

.image-modal-wrapper {
  .modal-mask {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background-color: rgba(0, 0, 0, .3);
    display: table;
    transition: opacity 0.3s ease;
    background-color: #f2f2f2;
  }

  .modal-wrapper {
    z-index: 1001;
    position: inherit;
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    /*width: 300px;*/
    position: inherit;
    margin: 0 auto;
    z-index: 1002;
    padding: 20px 30px;
    // background-color: #fff;
    border-radius: 2px;
    // box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }
  .modal-body {
    margin: 20px 0;
    padding: 10px;
  }

  .modal-default-button {
    float: right;
  }
  // The following styles are auto-applied to elements with transition="modal"
  //  when their visibility is toggled by Vue.js. You can easily play with the
  //   modal transition by editing these styles.
  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
    .close-button {
      pointer-events: auto;
      opacity: 0;
      transition: opacity 4s ease;
    }
  }

  .close-button {
    pointer-events: auto;
    position: absolute;

    opacity: 1;
    z-index: 1252;
    cursor: pointer;
    outline: none;

    border: none;
    background-color: rgba(0, 0, 0, 0.15);
    border-radius: 50%;
    // transition: opacity 4s ease;
    top: 3px !important;
    left: 1870px !important;
    display: flex;
    transform: scale(1);
    svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    &:hover {
      svg {
        path:first-child {
          fill: #5d5d5d;
          transition: all 0.4s ease;
        }
      }
      background-color: $borderColor;
      transform: scale(1.1);
      transition: all 0.4s ease;
      // opacity: 1;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.game {
  .modal-mask {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background-color: rgba(0, 0, 0, .3);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    z-index: 1001;
    position: inherit;
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    /*width: 300px;*/
    position: inherit;
    margin: 0 auto;
    z-index: 1002;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    // box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }
  .modal-body {
    margin: 20px 0;
    padding: 10px;
  }

  .modal-default-button {
    float: right;
  }
  // The following styles are auto-applied to elements with transition="modal"
  //  when their visibility is toggled by Vue.js. You can easily play with the
  //   modal transition by editing these styles.
  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
    .close-button {
      pointer-events: auto;
      opacity: 0;
      transition: opacity 4s ease;
    }
  }

  .close-button {
    pointer-events: auto;
    position: absolute;

    opacity: 1;
    z-index: 1252;
    cursor: pointer;
    outline: none;

    border: none;
    background-color: rgba(0, 0, 0, 0.15);
    border-radius: 50%;
    // transition: opacity 4s ease;
    top: 0 !important;
    right: 0 !important;
    display: flex;
    transform: scale(1);
    &:hover {
      svg {
        path:first-child {
          fill: #5d5d5d;
          // fill: $borderColor;
          transition: all 0.4s ease;
        }
      }
      background-color: $borderColor;
      // transform: scale(1.1);
      transition: all 0.4s ease;
      // opacity: 1;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.film {
  .modal-mask {
    position: fixed;
    z-index: 9995;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    z-index: 1001;
    position: inherit;
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    /*width: 300px;*/
    position: inherit;
    // margin: 0 auto;
    z-index: 1002;
    // padding: 20px 30px;
    background-color: #fff;
    // background-color: transparent !important;
    border-radius: 2px;
    // box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    padding: 0;
    width: 100%;
    height: 100%;
  }
  .modal-body-flex {
    width: 100%;
    height: 100%;
  }
  .modal-default-button {
    float: right;
  }
  // The following styles are auto-applied to elements with transition="modal"
  //  when their visibility is toggled by Vue.js. You can easily play with the
  //   modal transition by editing these styles.
  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);

    .close-button {
      pointer-events: auto;
      opacity: 0;
      transition: opacity 4s ease;
    }
  }
  .close-button {
    pointer-events: auto;
    position: absolute;

    opacity: 1;
    z-index: 1003;
    cursor: pointer;
    outline: none;
    // opacity: 1;
    border: none;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    // top: 110px !important;
    // right: 447px !important;
    // top: 16% !important;
    right: 0 !important;
    // transition: opacity 4s ease;
    display: flex;
    transform: scale(1);
    // background-color: rgba(93, 93, 93, 0.7);
    // svg {
    //     path:first-child {
    //         fill: $borderColor;
    //         transition: all 0.4s ease;
    //     }
    // }
    svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    &:hover {
      svg {
        path:first-child {
          fill: #5d5d5d;
          transition: all 0.4s ease;
        }
      }
      background-color: $borderColor;
      transform: scale(1.1);
      transition: all 0.4s ease;
      // opacity: 1;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.scratch {
  .modal-mask {
    position: fixed;
    z-index: 9995;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    z-index: 1001;
    position: inherit;
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    /*width: 300px;*/
    position: inherit;
    // margin: 0 auto;
    z-index: 1002;
    // padding: 20px 30px;
    // background-color: #fff;
    background-color: rgba(93, 93, 93, 0.23);
    // background-color: transparent !important;
    border-radius: 2px;
    // box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    padding: 0;
    width: 100%;
    height: 100%;
  }
  .modal-body-flex {
    width: 100%;
    height: 100%;
  }
  .modal-default-button {
    float: right;
  }
  // The following styles are auto-applied to elements with transition="modal"
  //  when their visibility is toggled by Vue.js. You can easily play with the
  //   modal transition by editing these styles.
  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);

    .close-button {
      pointer-events: auto;
      opacity: 0;
      transition: opacity 4s ease;
    }
  }
  .close-button {
    pointer-events: auto;
    position: absolute;

    opacity: 1;
    z-index: 1003;
    cursor: pointer;
    outline: none;
    // opacity: 1;
    border: none;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    padding: 0;
    // top: 110px !important;
    // right: 447px !important;
    top: 27% !important;
    left: 70% !important;
    // transition: opacity 4s ease;
    display: flex;
    transform: scale(1);
    svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    &:hover {
      svg {
        path:first-child {
          fill: #5d5d5d;
          transition: all 0.4s ease;
        }
      }
      background-color: $borderColor;
      transform: scale(1.1);
      transition: all 0.4s ease;
      // opacity: 1;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
